import _ from 'lodash'
export default function doLogin(state = [], action) {
  const newState = _.cloneDeep(state)
  switch (action.type) {
    case 'LOGGED_LOADING':
      return Object.assign({}, {}, {load: true})
    case 'LOGGED_IN':
      localStorage.setItem('user', JSON.stringify(action.data))
      return Object.assign({}, newState, {...action.data, load: false})
    case 'LOGIN_FAILED':
      return Object.assign({}, newState, { load: false, isLogged: action.data.isLogged, token: action.data.token, message: action.data.message, type: action.data.type, error: action.data.error })
    case 'LOGIN_RESET': 
      return Object.assign({}, {}, { ...state, error: false, message: '' })
    case 'LOGGED_OUT':
      localStorage.setItem('user', JSON.stringify(action.data))
      return Object.assign({}, {}, { isLogged: false, token: null, message: '', type: null })
    case 'LOGOUT_ERROR':
      return Object.assign({}, newState, { isLogged: false })
    case 'VALIDATE_USER_SUCCESS':
      if(action.data.success == false) {
        return Object.assign({}, {}, { isLogged: false, token: null, message: action.data.message, type: null })
      }
      return newState
    case 'VALIDATE_USER_FAILED':
      return Object.assign({}, {}, { isLogged: false, token: null, message: action.error.message, type: null })
    case 'GET_LAWYER': 
      return Object.assign({}, newState, { user: action.data, message: '', error: false})
    case 'GET_LAWYER_FAILED': 
      return Object.assign({}, {}, {...state, message: action.data.message, error: action.data.error})
    case 'UPDATE_LAWYER': 
      return Object.assign({}, {}, { ...state, user: action.data, message: 'user_profile_updated', error: false})
    case 'UPDATE_LAWYER_FAILED': 
      return Object.assign({}, {}, {...state, message: action.data.message, error: action.data.error})
    case 'LAWYER_MESSAGE_RESET': 
      return Object.assign({}, {}, {...state, message: ''})
    default:
      return state
  }
}
